export const getContainerStyles = () => ({
  background: "#FFFFFF",
  padding: "2% 10% 2% 10%",
  "> div": {
    display: "flex",
    gap: "64px",
    alignItems: "center",
  },
});
